import { render } from "./GoodsList.vue?vue&type=template&id=3930c908&scoped=true"
import script from "./GoodsList.vue?vue&type=script&lang=js"
export * from "./GoodsList.vue?vue&type=script&lang=js"

import "./GoodsList.vue?vue&type=style&index=0&id=3930c908&lang=scss&scoped=true"
import "./GoodsList.vue?vue&type=style&index=1&id=3930c908&lang=scss"

import exportComponent from "/Users/opm/opm-vue-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3930c908"]])

export default __exports__